/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%AA%81%E7%99%BC/823040/%E7%81%A3%E4%BB%94%E8%91%A1%E8%90%84%E9%85%92%E5%85%AC%E5%8F%B8%E6%94%B6%E5%81%87%E9%9B%BB%E9%83%B5-%E6%89%AE%E5%89%8D%E5%9F%B7%E8%91%A3%E8%A6%81%E6%B1%82%E5%8C%AF%E6%AC%BE-%E5%A4%B1-1470%E8%90%AC%E5%85%83'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E6%94%BF%E6%83%85/814347/%E9%81%B8%E8%88%89%E8%99%95%E8%81%B7%E5%93%A1%E8%B2%AA%E6%96%B9%E4%BE%BF-%E8%AA%A4%E6%B4%A91-5%E8%90%AC%E9%81%B8%E6%B0%91%E8%B3%87%E6%96%99-%E7%95%B6%E5%B1%80%E5%BE%AA%E7%B4%80%E5%BE%8B%E8%99%95%E5%88%86%E8%B7%9F%E9%80%B2'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/780730/%E7%A7%81%E9%9A%B1%E5%B0%88%E5%93%A1%E5%85%AC%E7%BD%B2%E6%8F%AD%E5%BA%B7%E5%81%A5%E9%86%AB%E7%99%82%E6%84%8F%E5%A4%96%E6%A3%84%E7%BD%AE294%E5%90%8D%E7%97%85%E4%BA%BA%E8%B3%87%E6%96%99-3%E5%80%8B%E6%9C%88%E5%BE%8C%E5%A7%8B%E9%80%9A%E5%A0%B1'
          );
        }}
        className="source3"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%AA%81%E7%99%BC/823040/%E7%81%A3%E4%BB%94%E8%91%A1%E8%90%84%E9%85%92%E5%85%AC%E5%8F%B8%E6%94%B6%E5%81%87%E9%9B%BB%E9%83%B5-%E6%89%AE%E5%89%8D%E5%9F%B7%E8%91%A3%E8%A6%81%E6%B1%82%E5%8C%AF%E6%AC%BE-%E5%A4%B1-1470%E8%90%AC%E5%85%83'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E6%94%BF%E6%83%85/814347/%E9%81%B8%E8%88%89%E8%99%95%E8%81%B7%E5%93%A1%E8%B2%AA%E6%96%B9%E4%BE%BF-%E8%AA%A4%E6%B4%A91-5%E8%90%AC%E9%81%B8%E6%B0%91%E8%B3%87%E6%96%99-%E7%95%B6%E5%B1%80%E5%BE%AA%E7%B4%80%E5%BE%8B%E8%99%95%E5%88%86%E8%B7%9F%E9%80%B2'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/780730/%E7%A7%81%E9%9A%B1%E5%B0%88%E5%93%A1%E5%85%AC%E7%BD%B2%E6%8F%AD%E5%BA%B7%E5%81%A5%E9%86%AB%E7%99%82%E6%84%8F%E5%A4%96%E6%A3%84%E7%BD%AE294%E5%90%8D%E7%97%85%E4%BA%BA%E8%B3%87%E6%96%99-3%E5%80%8B%E6%9C%88%E5%BE%8C%E5%A7%8B%E9%80%9A%E5%A0%B1'
          );
        }}
        className="source3"
      />
    </div>
  </>
);

export default Components004;
